<template>
    <div class="venue__list">
        <div class="venue__list_header">
            <component-induction-message
                :title="'Venues'"
                :content="'For events hosted in a real life location, venues are invaluable. They can be set up with an unlimited number of rooms, each with their own directions and capacity.'"
                :link-to="''"
                :theme="'tertiary'"
                :route-name="'ebs-venue-list'"
            ></component-induction-message>
            <view-actions
                :title="$t('ebs.venues.list.title.venues')"
                :cancel-button-active="false"
                :submit-button-text="$t('ebs.venues.list.buttons.createVenues')"
                :submit-button-active="user.isInfrastructureManager()"
                @emit-submit="createVenue"
            />
        </div>
        <div class="venue__list_main">
            <component-list
                :component-grid="VenueListGrid"
                :component-table="VenueListTable"
                :list-view-items="['table', 'grid']"
                :component-table-name="'venues'"
                :empty-state-title="'Venues to assign to events will appear here. Go ahead and create one by clicking Create venue.'"
                :filter-search-queryable="true"
                :filter-select-active="true"
                :filter-select-items="filtersSelect"
                :get-pagination-getter="'getVenuesPagination'"
                :get-items-getter="'getVenues'"
                :get-items-dispatch="'getVenues'"
                :item-name="['venue', 'venues']"
                :table-preferences-active="true"
                @emit-create="createVenue"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import VenueListGrid from '@/components/ebs/venues/list/VenueListGrid'
import VenueListTable from '@/components/ebs/venues/list/VenueListTable'
import { User } from '@/User'
import ComponentList from '@/components/default/shared/ComponentList'
import ComponentInductionMessage from '@/components/default/shared/ComponentInductionMessage'

export default {
  name: 'venue-list',
  data () {
    return {
      user: new User(),
      VenueListTable,
      VenueListGrid
    }
  },
  components: {
    ComponentInductionMessage,
    ComponentList,
    ViewActions
  },
  computed: {
    filtersSelect () {
      return [
        {
          key: 'status',
          label: 'Status',
          type: 'checkbox',
          values: [
            {
              label: 'Draft',
              value: 'draft'
            },
            {
              label: 'Active',
              value: 'active'
            }
          ]
        }
      ]
    }
  },
  methods: {
    createVenue () {
      this.$router.push({ name: 'ebs-venue-add' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/venues/venuelist";
</style>
